import { type FC } from "react";

import { CourseAdminCourseItem } from "./CourseAdminCourseItem";
import { CourseAdminGroupingItem } from "./CourseAdminGroupingItem";

import { selectCourseGroupingIdsWithCourses, selectUngroupedCourseIds } from "store/selectors";
import { useListSelector } from "store/store-hooks";

type CourseAdminSelectionListProps = {
  selectedGroupingIds: string[];
  selectedCourseIds: string[];
  onGroupingToggle: (groupingId: string) => void;
  onCourseToggle: (courseId: string) => void;
};

export const CourseAdminSelectionList: FC<CourseAdminSelectionListProps> = ({
  selectedGroupingIds,
  selectedCourseIds,
  onGroupingToggle,
  onCourseToggle,
}) => {
  const groupingIds = useListSelector(selectCourseGroupingIdsWithCourses);
  const ungroupedCourseIds = useListSelector(selectUngroupedCourseIds);
  const selectedGroupingIdSet = new Set(selectedGroupingIds);
  const selectedCourseIdSet = new Set(selectedCourseIds);

  if (groupingIds.length === 0 && ungroupedCourseIds.length === 0) {
    return null;
  }

  return (
    <div className="max-h-[240px] overflow-y-scroll rounded-lg border border-black-tint-90 p-2">
      {groupingIds.map((groupingId) => (
        <CourseAdminGroupingItem
          groupingId={groupingId}
          isGroupingSelected={selectedGroupingIdSet.has(groupingId)}
          key={groupingId}
          selectedCourseIds={selectedCourseIdSet}
          onCourseToggle={onCourseToggle}
          onGroupingToggle={onGroupingToggle}
        />
      ))}

      {ungroupedCourseIds.map((courseId) => (
        <div key={courseId}>
          <CourseAdminCourseItem
            courseId={courseId}
            isChecked={selectedCourseIdSet.has(courseId)}
            onToggle={onCourseToggle}
          />
        </div>
      ))}
    </div>
  );
};
